export default __webpack_public_path__ + "static/media/tagIcon-02.467c815c.svg";